// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"34":"c74e969c","292":"57979333","361":"56e19cdf","744":"51642e52"}[chunkId] + ".chunk.css";
};